/** Where the QTO Review sheet lives and where its data starts. Shared by the renderer, the reader and the log. */

export const SHEET_NAME = "QTO Review";

export const REVIEW_DATA_START_ROW = 5;

/** Hidden worksheet (Unhide via Excel): audit log of submitted Add/Update rows. */
